import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, isRef as _isRef } from "vue"

import { ref, onMounted, reactive, computed } from "vue";
import {
  getIspList,
  getLoginIsp,
  ispListType,
} from "@/api/request/certification";
import { ElMessage, FormRules, FormInstance } from "element-plus";
import store from "@/store";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'Visitor2ServiceProviderSignUpDialog',
  setup(__props) {

const { t } = useI18n();
function beforeClose(done: any) {
  store.commit("SET_VISITORS_SIGNUP_DIALOG", false);
  visitorSingnUpForm.value.name = "";
  visitorSingnUpForm.value.spName = "";
  visitorSingnUpForm.value.email = "";
  done();
}
function close() {
  store.commit("SET_VISITORS_SIGNUP_DIALOG", false);
}

const validatePass = (rule: any, value: any, callback: any) => {
  const emailRegex = /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/;
  if (
    visitorSingnUpForm.value.email &&
    !emailRegex.test(visitorSingnUpForm.value.email)
  ) {
    return callback(new Error(t("请输入正确的公司邮箱")));
  }
  callback();
};
const rules = reactive<FormRules>({
  spName: [
    { required: true, message: t("请选择素材服务商名称"), trigger: "blur" },
  ],
  name: [{ required: true, message: t("请输入姓名"), trigger: "blur" }],
  email: [
    { required: true, message: t("请输入公司邮箱"), trigger: "blur" },
    // { validator: validatePass, trigger: "blur" },
  ],
});

const visitorSignUpDialog = computed(() => {
  return store.state.user.visitorSignUpDialog;
});
const visitorSingnUpForm = ref({
  name: "",
  spName: "",
  email: "",
});
const visitorSingnUpFormRef = ref<FormInstance>();
function visitorSubmit() {
  if (!visitorSingnUpFormRef.value) return;
  visitorSingnUpFormRef.value.validate((valid) => {
    if (valid) {
      getLoginIsp({
        ...visitorSingnUpForm.value,
      })
        .then((res) => {
          ElMessage.success("身份校验成功");
          store.commit("SET_VISITORS_SIGNUP_DIALOG", false);
          localStorage.clear();
          localStorage.setItem(process.env.VUE_APP_TOKEN_KEY, res.data.token);

          store.dispatch("GetInfo");
        })
        .catch((err) => {
          console.log(err);
          ElMessage.error(err.msg);
        });
    }
  });
}
const ispList = ref([] as ispListType[]);
onMounted(() => {
  getIspList().then((res) => {
    ispList.value = res.data;
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(visitorSignUpDialog),
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(visitorSignUpDialog) ? (visitorSignUpDialog).value = $event : null)),
    title: _ctx.$t('服务商身份报名'),
    "destroy-on-close": "",
    width: "600px",
    "before-close": beforeClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "visitorSingnUpFormRef",
        ref: visitorSingnUpFormRef,
        rules: rules,
        model: visitorSingnUpForm.value,
        size: "default",
        "label-width": "140px",
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('姓名'),
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: visitorSingnUpForm.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visitorSingnUpForm.value.name) = $event)),
                placeholder: _ctx.$t('请输入姓名'),
                size: "small"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('素材服务商名称'),
            prop: "spName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: visitorSingnUpForm.value.spName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visitorSingnUpForm.value.spName) = $event)),
                placeholder: _ctx.$t('请选择素材服务商名称'),
                size: "small"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ispList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.businessId,
                      label: item.label,
                      value: item.label
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('公司邮箱'),
            prop: "email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: visitorSingnUpForm.value.email,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visitorSingnUpForm.value.email) = $event)),
                placeholder: _ctx.$t('请输入公司邮箱'),
                size: "small"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, { label: " " }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (visitorSubmit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("提交")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "small",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (close()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("取消")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})